module.exports = __webpack_public_path__ + "img/header_background.d6378f33.png";